import { Shape } from '../types/Shape';

export const handleShapeUpdate = (
  shapeId: string,
  updates: Partial<Shape> | { action: string; [key: string]: any },
  setShapes: React.Dispatch<React.SetStateAction<Shape[]>>
) => {
  // PDF 페이지 추가 요청 처리 (HTML 모드)
  if (updates && typeof updates === 'object' && 'action' in updates && updates.action === 'addPageBelowHTML') {
    const { pageNum, pdfFile, width, height, x, y, totalPages } = updates as any;
    
    // 최대 order + 2 (짝수)로 설정
    setShapes(prev => {
      const maxOrder = Math.max(...prev.map(s => s.order ?? 0), 0);
      const newOrder = maxOrder % 2 === 0 ? maxOrder + 2 : maxOrder + 1;
      
      const newPageShape: Shape = {
        id: `${Date.now()}-pdf-page-${pageNum}`,
        type: 'pdf',
        x,
        y,
        width,
        height,
        fill: '#FFFFFF',
        stroke: '#D1D5DB',
        strokeWidth: 1,
        pdfFile,
        currentPage: pageNum,
        totalPages,
        order: newOrder,
        renderMode: 'html',
      };
      
      return [...prev, newPageShape];
    });
    
    return;
  }
  
  // 기존 shape 업데이트
  setShapes(prev =>
    prev.map(shape =>
      shape.id === shapeId
        ? { ...shape, ...updates }
        : shape
    )
  );
};

